var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"split-section",class:[
		`split-section--image-${_vm.imageSide}`,
		`split-section--fit-${_vm.imageFit}`,
		{
			'has-image': _vm.imageSrc,
			'split-section--mobile-image-last': _vm.mobileImageLast,
			'split-section--has-aspect': _vm.visualAspectRatio,
			'split-section--visual-in-container': _vm.visualInContainer,
		},
	],style:(_vm.sectionVars)},[_c('div',{staticClass:"split-section__visual"},[(_vm.imageSrc)?_c('img',{staticClass:"split-section__image",attrs:{"src":_vm.imageSrc,"alt":_vm.imageAlt,"loading":"lazy"}}):_vm._e()]),_c('div',{staticClass:"split-section__content"},[(_vm.title)?_c('h2',{staticClass:"split-section__title headline-l",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.body)?_c('div',{staticClass:"split-section__body text-l",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e(),(_vm.$slots.footer)?_c('div',{staticClass:"split-section__footer"},[_vm._t("footer")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }